import { I } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationType, NotificationHeader, NotificationDetails, Modules, NotificationTextMessage } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { GetAllDislcosuresListBasedonType, MenuState, ToggleCheck } from '@app/core/Store';
import { GetAllContactsBasedonType, GetAllIndependentExaminers, GetBalancesheetDataById, GetExaminersBasedonId, GetTrusteesDataById, SaveBalancesheetDisclosures, SaveTrusteeDisclosures } from '@app/core/Store/report/report-settings';
import { AddClosePopupComponent, ConfirmationBoxComponent, ContactDetailPopupComponent, EditAuditReportPopupComponent } from '@app/modules/common';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-report-settings',
  templateUrl: './report-settings.component.html',
  styleUrls: ['./report-settings.component.scss']
})
export class ReportSettingsComponent implements OnInit {
  displayedColumns: string[] = ['name', 'address', 'actions'];
  dataSource: any[] = [];
  examinersDataSource: any[] = [];
  isAddingAllowed: boolean = true;
  tabList = [
    { name: 'Patron', buttonLabel: 'Add New Patron' },
    { name: 'Chairman', buttonLabel: 'Add New Chairman' },
    { name: 'Trustees', buttonLabel: 'Add New Trustee' },
    { name: 'Secretaries', buttonLabel: 'Add New Secretary' },
    { name: 'Bankers', buttonLabel: 'Add New Banker' },
    { name: 'Solicitors', buttonLabel: 'Add New Solicitor' },
    { name: 'Investment advisors', buttonLabel: 'Add New Investment advisor' }
  ];

  selectedTab: any = 1;
  trusteeReports: any[];
  balancesheetReports: any[];
  trusteeReportDetails: any;
  balancesheetReportDetails: any;

  @Select(MenuState.moduleId)
    moduleId$: Observable<number>;
    moduleId: Modules;
  
  @Select(MenuState.getSelectedMenuPermission)
    isViewPermission$: Observable<any>;
    
    commonNotificationText = NotificationTextMessage;
  commenceDate:any;
  constructor(private commonService: CommonService, public dialog: MatDialog, private store: Store, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.getContactDetails(1);
    this.getAllIndependentExaminers(); 
  }

  onTabChange(event: any): void{
    this.selectedTab = event.index + 1;
    switch (this.selectedTab) {
      case 2:
        this.selectedTab = 8;
        break;
      case 3:
        this.selectedTab = 2;
        break;
      case 4:
        this.selectedTab = 6;
        break;
      case 5:
        this.selectedTab = 3;
        break;
      case 6:
        this.selectedTab = 4;
        break;
      case 7:
        this.selectedTab = 5;
        break;
    }

    this.getContactDetails();
  }
  iscompanyRegistered:boolean;
  isCharitablecompany:boolean;
  isAudicted:boolean;
  getContactDetails(isCall?:number): void{
    this.store.dispatch(new GetAllContactsBasedonType(this.selectedTab)).pipe().subscribe(
      (response: any) => {
        this.dataSource = response?.reportSettings?.contacts;
        this.iscompanyRegistered=response?.reportSettings?.iscompanyRegistered;
        this.isCharitablecompany=response?.reportSettings?.charityType !== 3;
        this.isAudicted=response?.reportSettings?.isAudited;
        this.commenceDate=new Date(response?.reportSettings?.commencementDate);
        if((this.selectedTab === 1 || this.selectedTab === 5) && this.dataSource.length >= 1){
          this.isAddingAllowed = false;
        } else {
          this.isAddingAllowed = true;
        }
        if(isCall === 1){
          this.getAllDislcosuresListBasedonType('trustees');
          this.getAllDislcosuresListBasedonType('balanceSheet');
        }
       
      }
    );
  }

  getAllIndependentExaminers(): void{
    this.store.dispatch(new GetAllIndependentExaminers()).pipe().subscribe(
      (response: any) => {
        this.examinersDataSource = response?.reportSettings?.examiners;
      }
    );
  }

  getAllDislcosuresListBasedonType(type?: any): void{
    if(type == 'trustees'){
      this.store.dispatch(new GetAllDislcosuresListBasedonType('trustees',this.isAudicted)).pipe().subscribe(
        (response: any) => {
          this.trusteeReports = response?.common?.reports;
        }
      );
    } else if(type == 'balanceSheet'){
      this.store.dispatch(new GetAllDislcosuresListBasedonType('balanceSheet',this.isAudicted)).pipe().subscribe(
        (response: any) => {
          this.balancesheetReports = response?.common?.reports;
        }
      );
    }
  }

  onDeleteClick(id: any, isContact: boolean): void {
    this.dialog.open(ConfirmationBoxComponent, {
      data: {
        ids: id,
        type: ConfirmationType.Delete,
        moduleId: Modules.reportSettings,
        subModuleId: !isContact ? Modules.IndependentExaminerReport : null,
        totalNumberOfRecordSelected: 1,
        headerText: NotificationHeader.deleteConfirmation,
        detailText: NotificationDetails.deleteAllDetailText,
      },
    })
    .afterClosed()
    .subscribe((result) => {
      if (result) {
        if(isContact) this.getContactDetails(); 
        else this.getAllIndependentExaminers(); 
      }
    });
  }

  onCheckboxClick(event: any, report: any, type: string): void{
    this.spinner.show();
    const payload = {
      type: report.type,
      toggleFor: type,
      IsCheck: event.checked   
    }
    this.store.dispatch(new ToggleCheck(payload)).pipe().subscribe(
      (response: any) => {
        this.getAllDislcosuresListBasedonType(type);
      }
    );
  }

  getTrusteesDataById(type): void{
    this.store.dispatch(new GetTrusteesDataById(type)).pipe().subscribe(
      (response: any) => {
        this.trusteeReportDetails = response?.reportSettings?.trusteeReportDetails;
        this.editReport(this.trusteeReportDetails.title, this.trusteeReportDetails.content, 'trustees');
      }
    );
  }

  getBalancesheetDataById(type): void{
    this.store.dispatch(new GetBalancesheetDataById(type)).pipe().subscribe(
      (response: any) => {
        this.balancesheetReportDetails = response?.reportSettings?.balancesheetReportDetails;
        this.editReport(this.balancesheetReportDetails.title, this.balancesheetReportDetails.content, 'balanceSheet');
      }
    );
  }

  editReport(title: any, content: any, type: string){
    const dialogRef = this.dialog.open(EditAuditReportPopupComponent);

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.type = type;
    dialogRef.componentInstance.content = content;
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(type == 'trustees') this.trusteeReportDetails.content = result?.content;
        if(type == 'balanceSheet') this.balancesheetReportDetails.content = result?.content;
        this.saveReportDetails(type);
      }
    });
  }

  openEditDialog(isContact: boolean, element?: any,tab?:string): void {
    const dialogRef = this.dialog.open(ContactDetailPopupComponent, {
      disableClose: true
    });
    dialogRef.componentInstance.isContact = isContact;
    dialogRef.componentInstance.selectedId = element ? element.id : '';
    dialogRef.componentInstance.selectedContactType = this.selectedTab;
    dialogRef.componentInstance.tabName = tab;
     dialogRef.componentInstance.commenceDate=this.commenceDate;;
    dialogRef.afterClosed().subscribe(result => {
      if(isContact) this.getContactDetails(); 
      else this.getAllIndependentExaminers();
    });
  }

  saveReportDetails(type: string): void{
    if(type == 'trustees'){
      this.store.dispatch(new SaveTrusteeDisclosures(this.trusteeReportDetails)).pipe().subscribe(
        (response: any) => {
          this.commonService.onSucess(NotificationTextMessage.successMessage);
          this.getAllDislcosuresListBasedonType('trustees');
        }
      );
    } else if(type == 'balanceSheet'){
      this.store.dispatch(new SaveBalancesheetDisclosures(this.balancesheetReportDetails)).pipe().subscribe(
        (response: any) => {
          this.commonService.onSucess(NotificationTextMessage.successMessage);
          this.getAllDislcosuresListBasedonType('balanceSheet');
        }
      );
    }
  }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }

  formatAddress(element: any, isCountry : boolean): string {
    return [
      element?.address1,
      element?.address2,
      element?.city,
      element?.postCode,
      isCountry ? element?.county : element?.country
    ]
    .filter(v => v)
    .join(', ');
  }
}
